import { Button, ButtonProps } from "@mui/material";

export function AppButton(props: ButtonProps) {
    return (
        <Button
            variant="contained"
            color="primary"
            {...props}
        >
            {props.children}
        </Button>
    )

}